import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: 'users', loadChildren: () => import('./modules/users/users.module').then((m) => m.UsersModule) },
  {
    path: 'investment-companies',
    loadChildren: () => import('./modules/investment-companies/investment-companies.module').then((m) => m.InvestmentCompaniesModule)
  },
  { path: 'companies', loadChildren: () => import('./modules/companies/companies.module').then((m) => m.CompaniesModule) },
  { path: 'pep-list', loadChildren: () => import('./modules/pep-list/pep-list.module').then((m) => m.PepListModule) },
  { path: 'pitches', loadChildren: () => import('./modules/pitches/pitches.module').then((m) => m.PitchesModule) },
  { path: 'questions', loadChildren: () => import('./modules/questions/questions.module').then((m) => m.QuestionsModule) },
  { path: 'analyses', loadChildren: () => import('./modules/analyses/analyses.module').then((m) => m.AnalysesModule) },
  { path: 'subscriptions', loadChildren: () => import('./modules/subscriptions/subscriptions.module').then((m) => m.SubscriptionsModule) },
  { path: 'investments', loadChildren: () => import('./modules/investments/investments.module').then((m) => m.InvestmentsModule) },
  { path: 'inquiries', loadChildren: () => import('./modules/contact-us/contact-us.module').then((m) => m.ContactUsModule) },
  {
    path: 'self-publishes',
    loadChildren: () => import('./modules/self-publishes/self-publishes.module').then((m) => m.SelfPublishesModule)
  },
  { path: 'statistics', loadChildren: () => import('./modules/statistics/statistics.module').then((m) => m.StatisticsModule) },
  {
    path: 'second-hand-market',
    loadChildren: () => import('./modules/second-hand-market/second-hand-market.module').then((m) => m.SecondHandMarketModule)
  },
  {
    path: 'tags',
    loadChildren: () => import('./modules/tags/tags.module').then((m) => m.TagsModule)
  },
  {
    path: 'sp-access-requests',
    loadChildren: () => import('./modules/sp-access-requests/sp-access-requests.module').then((m) => m.SPAccessRequestsModule)
  },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '', pathMatch: 'full', redirectTo: 'users' },
  { path: '**', redirectTo: 'page-not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
